// simply expose Hapimap classes into the browser global scope
import HapimapLoader from '../src/Hapimap/loader.js';
window.HapimapLoader = HapimapLoader;